import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AsyncDropdown } from '@ami/react/core';
import { ProductGroupFilter } from '../products/productGroupFilter';
import { ProductGroup } from '../products/productGroup';

export default class ProductGroupsAsyncDropdown extends Component {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  };
  async fetchItems(name) {
    return await ProductGroup.search(new ProductGroupFilter({ name: name }), 0);
  }
  render() {
    const { ...rest } = this.props;
    return (
      <AsyncDropdown
        placeholder={this.props.placeholder || 'All'}
        isClearable={true}
        fetchItems={this.fetchItems}
        prepopulateFromStorage={true}
        {...rest}
      />
    );
  }
}
